import React, {Component} from 'react';
import SectionFAQ from './FAQ/SectionFAQ'
import Header from './Shared/Header';
import BottonPushes from './Shared/BottonPushes';
import ArticleBox from './Articles/ArticleBox';
import shortid from "shortid";

class FAQPageContent extends Component {
    render() {
        return (
            <div>
                {<Header breadcrumbs={this.props.breadcrumbs} topHeader={this.props.faqJson.Sliders[0]} newClassName={"product-index-visual"} />}
                <div className="main">
                    <div className="faq">
                    {this.props.faqJson.Sections.map((section) => {
                        return <SectionFAQ section={section}  />
                    })}
                    </div>
                    <div className="main informational-boxes">
                        {this.props.faqJson.ArticleBoxes ? this.props.faqJson.ArticleBoxes.map((box) => {
                            return <ArticleBox key={shortid.generate()} box={box} />
                        }) : null}
                    </div>
                    {<BottonPushes
                        bottonPushes={this.props.faqJson.BottomTiles}
                        salonFinder={this.props.faqJson}
                        salonCountries={this.props.salonCountries}
                    />}
                </div>
            </div>
        )
    }
}

export default FAQPageContent;
